import React from "react";
import { Counterparty } from "@common/types/counterparty";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface Props {
    show: boolean;
    counterparty: Pick<Counterparty, "name">;
    mergeTargetName?: string;
    onConfirm: () => Promise<unknown>;
    onHide: () => void;
}

export const DisableCounterpartyInsteadModal: React.FC<Props> = ({
    show,
    counterparty,
    mergeTargetName,
    onConfirm,
    onHide,
}) => (
    <ConfirmationModal
        show={show}
        onHide={onHide}
        title="Counterparty has locked transactions"
        question={
            <p className="mb-0">
                <strong className="font-weight-medium">
                    {counterparty.name}
                </strong>{" "}
                is assigned to transactions in locked periods, which can&apos;t
                be modified. You can disable{" "}
                <strong className="font-weight-medium">
                    {counterparty.name}
                </strong>{" "}
                instead —{" "}
                {mergeTargetName ? (
                    <>
                        its unlocked transactions will be reassigned to{" "}
                        <strong className="font-weight-medium">
                            {mergeTargetName}
                        </strong>
                    </>
                ) : (
                    <>
                        its unlocked transactions will have the counterparty
                        cleared
                    </>
                )}
                , and locked transactions will keep it.
            </p>
        }
        yes="Disable counterparty"
        no="Cancel"
        onConfirm={onConfirm}
        onReject={onHide}
    />
);
